import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('PaymentDetails', PaymentDetailsData);

    PaymentDetailsData.$inject = ['UtilSvc', 'PaymentRequest', 'CURRENCY'];

    /* @ngInject */
    function PaymentDetailsData(UtilSvc, PaymentRequest, CURRENCY) {
        PaymentDetails.prototype = {
            build: build,
        };

        function PaymentDetails(paymentDetailsData) {
            if (paymentDetailsData) {
                this.build(paymentDetailsData);
            }
        }

        return PaymentDetails;

        function build(paymentDetailsData) {
            this.eid = paymentDetailsData.eid || null;
            this.createdDate = UtilSvc.parseDate(paymentDetailsData.createdDate) || null;
            this.updatedDate = UtilSvc.parseDate(paymentDetailsData.updatedDate) || null;
            this.status = paymentDetailsData.status || null;
            this.invoiceId = paymentDetailsData.invoiceId || null;
            this.amount = paymentDetailsData.amount || null;
            this.currency = _.find(CURRENCY, { code: paymentDetailsData.currency }).symbol || null;

            this.buyer = angular.copy(paymentDetailsData.buyer);
            this.seller = angular.copy(paymentDetailsData.seller);

            this.requests = _.map(paymentDetailsData.requests, req => new PaymentRequest(req)) || null;
        }
    }
})();
